<template>
  <div class="d-flex align-items-center border p-1">
    <!-- <span class="search-icon"> -->
    <i class="fa fa-search" />
    <!-- </span> -->
    <b-form-input
      v-model="input"
      @input="updateInput"
      style="flex-grow: 1; border: 0 none; outline: 0"
      :style="styleSearch"
      type="text"
      class="search-input ng-pristine ng-valid ng-touched border-none shadow-none"
      autoComplete="off"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    styleSearch: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      input: "",
    };
  },
  watch: {
    value: {
      handler(after) {
        this.input = after;
      },
      immediate: true,
    },
  },
  methods: {
    updateInput() {
      this.$emit("input", this.input);
    },
  },
};
</script>